import { OpenMarketTradeParams } from '../types';


export const checkOpenMarketTradeParamsEq = (
    paramsA: OpenMarketTradeParams | undefined,
    paramsB: OpenMarketTradeParams | undefined,
): boolean => {
    if (paramsA == paramsB) {
        return true;
    }
    if (!paramsA || !paramsB) {
        return false;
    }

    if (paramsA.pythUpdateData.length !== paramsB.pythUpdateData.length) {
        return false;
    }
    if (
        paramsA.oracleUpdateData.pythPriceUpdateData.length !==
        paramsB.oracleUpdateData.pythPriceUpdateData.length
    ) {
        return false;
    }
    if (
        paramsA.oracleUpdateData.pythProPriceUpdateData.length !==
        paramsB.oracleUpdateData.pythProPriceUpdateData.length
    ) {
        return false;
    }

    return (
        paramsA.pairBase == paramsB.pairBase &&
        paramsA.amountIn == paramsB.amountIn &&
        paramsA.price == paramsB.price &&
        paramsA.isLong == paramsB.isLong &&
        paramsA.tokenIn == paramsB.tokenIn &&
        paramsA.lvToken == paramsB.lvToken &&
        paramsA.qty == paramsB.qty &&
        paramsA.stopLoss == paramsB.stopLoss &&
        paramsA.takeProfit == paramsB.takeProfit &&
        paramsA.broker == paramsB.broker &&
        paramsA.value == paramsB.value &&
        paramsA.extraFee == paramsB.extraFee &&
        paramsA.pythUpdateData.join() == paramsB.pythUpdateData.join() &&
        paramsA.oracleUpdateData.pythPriceUpdateData.join() ==
            paramsB.oracleUpdateData.pythPriceUpdateData.join() &&
        paramsA.oracleUpdateData.pythProPriceUpdateData.join() ==
            paramsB.oracleUpdateData.pythProPriceUpdateData.join()
    )
}